import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-upload-file',
  imports: [AgentActionDirective],
  templateUrl: './upload-file.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upload-file.component.scss',
})
export class UploadFileComponent {
  @Input() public label = 'Upload File';
  @Input() public labelIsHidden = false;
  @Input() public buttonLabel = 'Choose File';
  @Input() public accept = '.xml';
  @Input() public disabled = false;
  @Input() public multiple = false;
  @Input() public showCloseButton = true;
  @Output() public fileSelected = new EventEmitter<File[]>();
  @Output() public closeComponent = new EventEmitter<void>();

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      this.fileSelected.emit(files);
    }
  }
}
